import React from 'react';
import {
  oneOfType, arrayOf, node, string, object,
} from 'prop-types';
import ConversionFlowHeader from '../ConversionFlowHeader';

const Layout = ({ children, market, newSignupHeader }) => (
  <div>
    <ConversionFlowHeader market={market} newSignupHeader={newSignupHeader} />
    {children}
  </div>

);

Layout.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  market: string,
  newSignupHeader: object,
};
export default Layout;
